export default __webpack_public_path__ + "static/media/house.8f607dd3.svg";